var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inspection-level-badge",class:_setup.badgeClass},[_vm._v(" "+_vm._s(_setup.levelLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }